import React from 'react';
import Praktisk from '../components/Praktisk';

const PracticalPage = () => {
  return (
    <div className="pt-[72px]">
      <Praktisk />
    </div>
  );
};

export default PracticalPage;
